/**
 * True when `pathname` is `prefix` or a page below it on a segment boundary, so `/apps` matches
 * `/apps/a` and never `/appsx`. The landing and the active section share this one rule.
 */
export function isPathUnder(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}
